module.exports = __webpack_public_path__ + "static/media/wall-clock-white.59c4b6a9.svg";